var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionShowMe } from "./actionShowMe";
import { IdShowMeFeature } from "./IdShowMeFeature";
var initial = {};
export var reducerShowMe = function (state, action) {
    if (state === void 0) { state = initial; }
    var _a, _b;
    if (action.type === TypeActionShowMe.SelectBuildingInfoInBuildMenu &&
        action.tabId &&
        action.buildingId) {
        var buildingId = action.buildingId, tabId = action.tabId;
        return __assign({}, state, (_a = {}, _a[IdShowMeFeature.BuildingMenu] = {
            buildingId: buildingId,
            isConsumed: false,
            tabId: tabId,
        }, _a));
    }
    else if (action.type === TypeActionShowMe.ConsumeBuildingInfoInInBuildMenu) {
        return __assign({}, state, (_b = {}, _b[IdShowMeFeature.BuildingMenu] = __assign({}, state[IdShowMeFeature.BuildingMenu], { isConsumed: true }), _b));
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/reducerShowMe.ts
// module id = 2977
// module chunks = 3